<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    role="presentation"
    :class="[itIsLink ? 'icon-link' : '']"
    :style="CustomStyle"
  >
    <title :id="iconName" lang="en">{{ iconName }}</title>
    <g :fill="iconColor">
      <slot />
    </g>
    <slot name="sub-menu"></slot>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 30
    },
    height: {
      type: [Number, String],
      default: 25
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    viewBox: {
      type: String,
      default: '0 0 25 25'
    },
    itIsLink: {
      type: Boolean,
      default: false
    },
    CustomStyle: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  overflow: visible !important;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
.icon-link {
  cursor: pointer;
}
</style>
